import { useEffect } from 'react';
import i18n from './react-i18n';
import { getUserPreferences, saveUserPreferences } from '../services/api';
import { useAuth } from '../contexts/AuthContext.helpers.js';

export default function PrefsBootstrap() {
  const { user } = useAuth();

  const userId = user?.id;

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const stored = typeof window !== 'undefined'
        ? (localStorage.getItem('userLocale') || localStorage.getItem('wms-user-locale'))
        : null;

      if (userId) {
        try {
          const prefs = await getUserPreferences(userId);
          const backendLang = prefs && prefs.language;
          const next = stored || backendLang;
          if (next && !cancelled) {
            await i18n.changeLanguage(next);
          }
          if (stored && backendLang && stored !== backendLang) {
            try {
              await saveUserPreferences(userId, { language: stored });
            } catch (error) { console.error(error); }
          }
        } catch {
          if (stored && !cancelled) {
            await i18n.changeLanguage(stored);
          }
        }
      } else if (stored && !cancelled) {
        await i18n.changeLanguage(stored);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);
  return null;
}
